<template>
  <v-menu transition="scale-transition" :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <v-text-field
        :model-value="timestamp ? $utils.humanFromVuetify($utils.vuetifyTimestamp(timestamp)) : null"
        :label="label"
        :placeholder="placeholder"
        :clearable="clearable"
        :disabled="disabled"
        @click:clear="onClear"
        readonly
        v-bind="props"
      ></v-text-field>
    </template>
    <template v-slot:default="{ isActive }">
      <MinimalDatePicker
        :model-value="$utils.dateFromTimestamp(timestamp)"
        :disabled="disabled"
        :first-day-of-week="1"
        @update:model-value="
          (date) => {
            changed(date)
            isActive.value = false
          }
        "
      ></MinimalDatePicker>
    </template>
  </v-menu>
</template>

<script>
import MinimalDatePicker from '@/components/ui/MinimalDatePicker'

export default {
  name: 'DatePickerPlus',
  components: { MinimalDatePicker },
  props: ['timestamp', 'placeholder', 'clearable', 'label', 'disabled'],
  methods: {
    changed(date) {
      this.$emit('update:timestamp', this.$utils.timestampFromDate(date))
    },
    onClear() {
      this.$emit('update:timestamp', null)
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.v-field) {
  font-size: $control-font-size;
}
:deep(.v-input__prepend),
:deep(.v-input__append) {
  align-items: center;
  padding-top: 0;
}
</style>
